import React, { useState } from "react";
import {
  Button,
  Card,
  Form,
  Input,
  Typography,
  message,
  Modal,
  Row,
} from "antd";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { API_PATH } from "../constants/ApiPath";
import CircularProgress from "components/CircularProgress/index";
import { deleteEngineerById } from "../api/endpoints";
import { removeXMPP } from "../chatServices/XMPPservice";

const { Title, Paragraph } = Typography;
const FormItem = Form.Item;

const formItemLayout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const AccountDeletion = ({ form }) => {
  const history = useHistory();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [cloader, setCloader] = useState(false);
  const { getFieldDecorator, validateFields } = form;
  const [userData, setUserData] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setCloader(true);

    validateFields(async (err, values) => {
      if (!err) {
        if (!values.email || !values.password) {
          message.error("Please enter your email and password!");
          setCloader(false);
          return;
        }
        const user = {
          email: values.email,
          password: values.password,
        };
        try {
          const res = await axios.post(
            API_PATH.concat("/partner/login/"),
            user
          );
          if (res.data["status"] === 200) {
            localStorage.setItem("token", res.data["token"]);
            localStorage.setItem("uuid", res.data["uuid"]);
            localStorage.setItem("user_uuid", res.data["uuid"]);
            localStorage.setItem("ticket_role", res.data["ticket_role"]);
            localStorage.setItem("all_roles", res.data["all_roles"]);
            setIsLoggedIn(true);
            setUserData(res.data);
          } else {
            message.error(res.data["message"]);
          }
        } catch (error) {
          if (error.response?.status === 401) {
            message.error(error.response.data["message"]);
          } else {
            message.error(error.toString());
          }
        } finally {
          setCloader(false);
        }
      }
    });
  };

  const deleteConfirm = async () => {
    setCloader(true);
    try {
      const response = await deleteEngineerById();
      if (response.data?.status === 200) {
        message.success("Account Deletion Requested");
        localStorage.clear();
        history.push("/portals");
        removeXMPP();
      } else {
        message.error(
          response?.data?.message || "Error Requesting Account Deletion!"
        );
      }
    } catch (error) {
      message.error("Error Requesting Account Deletion!");
    } finally {
      setCloader(false);
    }
  };

  function warning() {
    Modal.warning({
      title: "Warning",
      content: "This will delete your account and all associated data!.",
      onOk() {
        deleteConfirm();
      },
    });
  }

  return (
    <>
      <div style={{ maxWidth: 800, margin: "40px auto", padding: "0 20px" }}>
        <Card>
          <Row
            style={{
              alignItems: "center",
              justifyContent: "center",
              margin: 20,
              marginBottom: 50,
            }}
          >
            <img
              src={require("assets/images/LogoUniserved.png")}
              alt="Neature"
              style={{ height: 80, marginRight: 20 }}
            />
            <Title level={2} style={{ textAlign: "center" }}>
              UniservedFSM
            </Title>
          </Row>
          <Typography>
            <Title level={4}>Account Deletion</Title>

            <Paragraph>
              You can request deletion of your account and associated personal
              data at any time. Here's what you need to know:
            </Paragraph>

            <Title level={4}>What happens when you delete your account:</Title>
            <ul>
              <li>Your account information will be permanently deleted</li>
              <li>Your personal data will be removed from our systems</li>
              <li>You will lose access to all services and features</li>
              <li>This action cannot be undone</li>
            </ul>

            <Title level={4}>Data Retention:</Title>
            <Paragraph>
              Some information may be retained for legal, security, or business
              requirements in accordance with our{" "}
              <a
                href="https://www.uniserved.com/privacy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                privacy policy
              </a>{" "}
              and applicable laws. Any retained data will be handled as per our{" "}
              <a
                href="https://www.uniserved.com/privacy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                privacy policy
              </a>
              .
            </Paragraph>

            {!isLoggedIn ? (
              <>
                <Title level={4}>
                  Please login to continue with account deletion:
                </Title>
                <Form
                  {...formItemLayout}
                  onSubmit={handleSubmit}
                  className="gx-signin-form gx-form-row0 gx-mt-4"
                >
                  <FormItem label="Email">
                    {getFieldDecorator("email", {
                      initialValue: "",
                      rules: [
                        {
                          required: true,
                          type: "email",
                          message: "Please enter a valid email!",
                        },
                      ],
                    })(<Input placeholder="Email" />)}
                  </FormItem>

                  <FormItem label="Password">
                    {getFieldDecorator("password", {
                      initialValue: "",
                      rules: [
                        {
                          required: true,
                          message: "Please enter your Password!",
                        },
                      ],
                    })(<Input.Password placeholder="Password" />)}
                  </FormItem>

                  <FormItem>
                    <Button loading={cloader} type="primary" htmlType="submit">
                      Login to Continue
                    </Button>
                  </FormItem>
                </Form>
              </>
            ) : (
              <Card style={{ margin: 24 }}>
                <Title level={4}>
                  Are you sure you want to delete your account?
                </Title>
                <Paragraph>
                  This action will delete your account and all associated data.
                </Paragraph>

                <Paragraph>Name: {userData?.fullname}</Paragraph>
                <Paragraph>Email: {userData?.email}</Paragraph>

                <Button
                  type="danger"
                  loading={cloader}
                  onClick={() => {
                    warning();
                  }}
                >
                  Request Account Deletion
                </Button>
              </Card>
            )}
          </Typography>
        </Card>

        {cloader && (
          <div className="gx-loader-view">
            <CircularProgress />
          </div>
        )}
      </div>
    </>
  );
};

export default Form.create()(AccountDeletion);
